export enum DiscountApplyToTypes {
  LIST_PRICE = 'list_price',
  STD_COST = 'std_cost',
}

export enum DiscountPayloadType {
  DISCOUNT = 'base',
  MARGIN = 'base_margin',
  COST_DISCOUNT = 'base_cost_discount',
  MANUFACTURER = 'manufacturer',
  CATEGORY = 'category',
  PART_FIELD = 'part_field',
}

export enum PartFieldOperator {
  EQ = 'eq',
  NE = 'ne',
  GT = 'gt',
  GTE = 'gte',
  LT = 'lt',
  LTE = 'lte',
  CONTAINS = 'contains',
  BEGINS_WITH = 'begins_with',
}
